import {
  Button,
  ButtonToolbar,
  Card,
  Form,
  Input,
  InputProps,
  Message,
  Modal,
  Radio,
  RadioGroup,
  Stack
} from 'rsuite';
import ProvisionIcon from '../../images/account/provision.svg';
import { useCallback, useEffect, useState } from 'react';
import React from 'react';
import { t } from 'i18next';
import { useProvisionRequestMutation } from '@monorepo/shared';
interface IProps {
  region: Record<string, any>;
  account: Record<string, any>;
  instanceList?: Array<Record<string, any>>;
  callBack?: () => void;
}
type TextareaProps = InputProps & React.ComponentProps<'textarea'>;

const Options: Record<string, any> = {
  delete: {
    title:
      'Delete Existing Instance ( Warning: This will permanently delete all logs and data )',
    description:
      'The support team will remove the existing instance to allow a clean provisioning of the FortiSOC Cloud Service.'
  },
  keep: {
    title: 'Keep Existing Instance',
    description:
      'The support team will onboard the existing Instance into the FortiSOC Cloud Service.'
  }
};

const TextareaBase = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => <Input {...props} as="textarea" ref={ref} />
);
export const Textarea = React.memo(TextareaBase);

export const FAZAction = ({
  region,
  account,
  instanceList,
  callBack
}: IProps) => {
  const [message, setMessage] = useState<string>('');
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [formValue, setFormValue] = useState<Record<string, any>>({});
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [submitRequest, { isError, error, isSuccess }] =
    useProvisionRequestMutation();
  const onSubmit = () => {
    console.info('submit instance retention', formValue, region);
    submitRequest({
      account_id: account.account_id,
      region: region,
      parameters: instanceList?.map((obj: Record<string, any>) => ({
        ...obj,
        action: formValue?.[obj.name]?.toUpperCase()
      })),
      additional_notes: formValue.note || ''
    });
    setDialogOpen(false);
  };
  const initFormValue = useCallback(() => {
    if (instanceList && instanceList.length > 0) {
      const resObj = instanceList.reduce(
        (
          res: Record<string, any>,
          instance: Record<string, any>,
          i: number
        ) => {
          return {
            ...res,
            [`${instance.name}`]: ''
          };
        },
        {}
      );
      setRequiredFields(instanceList.map((inst) => inst.name));
      setFormValue({ ...resObj, note: '' });
    }
  }, [instanceList]);
  useEffect(() => {
    if (isError) {
      const errMsg =
        (error as any)?.data?.detail ||
        (error as any)?.data?.message ||
        'An unexpected error occurred. Please try again later.';
      setMessage(errMsg);
      setShowMessage(true);
    }
  }, [isError, error]);
  useEffect(() => {
    if (isSuccess) {
      if (callBack) {
        callBack();
      }
    }
  }, [isSuccess]);
  useEffect(() => {
    initFormValue();
  }, [instanceList]);
  return (
    <>
      <Stack
        spacing={'30px'}
        className="provision-container"
        alignItems="flex-start"
      >
        <Stack.Item>
          <img src={ProvisionIcon} className="service-icon" />
        </Stack.Item>
        <Stack.Item flex={1} className="info-content">
          <div className="service-title">{` Provision Service`}</div>
          {showMessage ? (
            <Message
              showIcon
              closable
              onClose={() => {
                setShowMessage(false);
                setMessage('');
              }}
              type="error"
              header="A problem occurred:"
              style={{ marginBottom: '20px' }}
            >
              <ul>
                {message.split('|')?.map((str: string, index: number) => (
                  <li key={index}>{str}</li>
                ))}
              </ul>
            </Message>
          ) : (
            <></>
          )}
          <div className="info-row" style={{ color: '#B0B0B0' }}>
            <div>
              {'Our system has detected below existing Cloud Instance(s).'}
            </div>
            <div>
              {
                'To proceed with the provisioning of the FortiSOC Cloud Service, please select one of the following options for instance(s):'
              }
            </div>
          </div>
          <Form
            fluid
            layout="vertical"
            formValue={formValue}
            onChange={(formValue) => {
              setFormValue(formValue);
            }}
            checkTrigger="blur" // <— DO THIS
          >
            <div className="instances-cards">
              {instanceList?.length &&
                instanceList.map((item: Record<string, any>, key: number) => (
                  <Card
                    size="md"
                    key={key}
                    style={{ marginBottom: '10px', borderRadius: '0px' }}
                  >
                    <Card.Header as="h6">{item.name}</Card.Header>
                    <Card.Body>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>
                          {'Instance URL: '}
                        </span>
                        <span style={{ fontSize: '0.9em', opacity: '0.9' }}>
                          {item.host}
                        </span>
                      </div>
                      <Form.Group controlId="action" aria-required>
                        <Form.Control
                          name={`${item.name}`}
                          accepter={RadioGroup}
                        >
                          {Object.keys(Options).map((key) => (
                            <div key={key}>
                              <Radio value={key}>{Options[key].title}</Radio>
                              <div
                                style={{ marginLeft: '12px', color: '#6C6C6C' }}
                              >
                                {Options[key].description}
                              </div>
                            </div>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                ))}
            </div>
            {/* <RadioGroup value={action} onChange={(v: any) => setAction(v)}>
              {Object.keys(Options).map((key) => (
                <div key={key} style={{ marginBottom: '16px' }}>
                  <Radio value={key}>{Options[key].title}</Radio>
                  <div style={{ marginLeft: '26px', color: '#6C6C6C' }}>
                    {Options[key].description}
                  </div>
                </div>
              ))}
            </RadioGroup> */}
            <Form.Group controlId="note">
              <Form.ControlLabel style={{ color: '#b0b0b0' }}>
                Additional Notes
              </Form.ControlLabel>
              <Form.Control
                name="note"
                rows={3}
                accepter={Textarea}
                style={{ minWidth: '100%' }}
              />
            </Form.Group>
            <ButtonToolbar>
              <Button
                appearance="ghost"
                className="action-btn"
                onClick={() => {
                  initFormValue();
                }}
              >
                Reset
              </Button>
              <Button
                appearance="primary"
                className="action-btn"
                disabled={requiredFields.some((field) => !formValue[field])}
                onClick={() => {
                  setDialogOpen(true);
                }}
              >
                {'Submit'}
              </Button>
            </ButtonToolbar>
            <div style={{ height: '80px' }}></div>
          </Form>
          <Modal
            backdrop="static"
            keyboard={false}
            open={dialogOpen}
            onClose={() => {
              setDialogOpen(false);
            }}
          >
            {/* <Modal.Header></Modal.Header> */}

            <Modal.Body>
              <div style={{ marginBottom: '10px' }}>
                {t('common.provision.confirmDialog.title')}
              </div>
              {
                <ul style={{ color: 'orange' }}>
                  {requiredFields.map((field, index) => (
                    <li key={index}>
                      <div
                        style={{ minWidth: '160px', display: 'inline-block' }}
                      >{`Instance ${field}:`}</div>
                      <div style={{ display: 'inline-block' }}>
                        {Options[formValue?.[field]]?.title}
                      </div>
                    </li>
                  ))}
                  <li>
                    <div>{`Additional Note: ` + formValue.note}</div>
                  </li>
                </ul>
              }
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  setDialogOpen(false);
                }}
                appearance="subtle"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  onSubmit();
                }}
                appearance="primary"
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>
        </Stack.Item>
      </Stack>
    </>
  );
};
